
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[orgSlug]/home",
      function () {
        return require("private-next-pages/org/[orgSlug]/home.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/org/[orgSlug]/home"])
      });
    }
  